import {
  ModuleEvent,
  PostModuleEventRequest,
  GetEventsResponseSerialized as GetEventsResponse,
  GetEventsResponseRS,
  GetDefinitionsResponse,
  GetDefinitionsResponseRecord,
  GetVersionDefinitionsResponse,
  GetVersionDefinitionsResponseRecord,
  GetLibraryResponse,
  GetLibraryResponseRecord,
} from '../../types/routes/module';
import { makeRequest } from '.';
import { routes } from '../../types/routes';

export interface MarkMessageRequest {
  readMessages: ModuleEvent[];
  sessionId: string;
  runId: string | null;
}

export const getEvents = async (
  classroomId: number | null,
  classId: number,
  moduleId: string | null,
  after: number | null = null,
  before: number | null = null,
): Promise<GetEventsResponse> => {
  const rge = moduleId
    ? classroomId
      ? routes.getClassroomModuleEvents
      : routes.getClassModuleEvents
    : classroomId
      ? routes.getClassroomEvents
      : routes.getClassEvents;
  let path = rge.path;
  if (moduleId) path = path.replace(':moduleId', moduleId);
  if (classroomId) path = path.replace(':classroomId', classroomId.toString());
  else path = path.replace(':classId', classId.toString());
  const query = new URLSearchParams();
  if (after) query.append('after', after.toString());
  if (before) query.append('before', before.toString());
  // For debugging error response only.
  // Otherwise, this should be false!
  if (false) {
    // "htmlerror" or "jsonerror"
    query.append('htmlerror', '1');
  }
  if (query.toString()) path += '?' + query;
  const response = await makeRequest(rge.method, path);
  return GetEventsResponseRS.check(response.data);
};

/*
 * Use the moduleId, taskId, and runId of the original message.
 * Use the most recent sessionId, so it doesn't screw up sessions
 */
export const markMessagesAsRead = async ({ readMessages, sessionId }: MarkMessageRequest): Promise<void> => {
  await makeRequest(
    routes.postModuleEvent.method,
    routes.postModuleEvent.path,
    readMessages.map(
      ({ id, moduleId, taskId, runId, properties }: ModuleEvent): PostModuleEventRequest => ({
        moduleId,
        taskId,
        action: 'message read',
        // For the 2025 version, the message id is sent with the log message
        // and the sender is specified
        // Older versions use the id of the module_event table entry
        properties: { id: 'id' in properties ? properties.id : id },
        sessionId,
        runId,
      }),
    ),
  );
};

export const getDefinitions = async (): Promise<GetDefinitionsResponse> => {
  const route = routes.getDefinitions;
  const response = await makeRequest(route.method, route.path);
  return GetDefinitionsResponseRecord.check(response.data);
};

export const getVersionDefinitions = async (version: string): Promise<GetVersionDefinitionsResponse> => {
  const route = routes.getVersionDefinitions;
  const query = route.path.replace(':versionId', version);
  const response = await makeRequest(route.method, query);
  return GetVersionDefinitionsResponseRecord.check(response.data);
};

export const getLibrary = async (): Promise<GetLibraryResponse> => {
  const route = routes.getLibrary;
  const response = await makeRequest(route.method, route.path);
  return GetLibraryResponseRecord.check(response.data);
};
